module.exports = __webpack_public_path__ + "media/images/pen_icon-d2d72317.png";